import { Group, Stack, Text } from '@mantine/core'

/** Rótulo à esquerda, valor à esquerda — a mesma linha do detalhe do robô. */
export function Linha({ rotulo, children }: { rotulo: string; children: React.ReactNode }) {
  return (
    <Group align="flex-start" wrap="nowrap" gap="md">
      <Text size="sm" c="dimmed" w={190} style={{ flexShrink: 0 }}>{rotulo}</Text>
      <Stack gap={2}>{children}</Stack>
    </Group>
  )
}
